<div #gmap class="height-100-35 map-main" id="map"></div>

<div class="map-buttons">
	<app-gmap-button [options]="mapService.mapButtons.pops" (click)="onClickMapButton('pops')"></app-gmap-button>
	<app-gmap-button
		[options]="mapService.mapButtons.covered_ab"
		(click)="onClickMapButton('covered_ab')"
	></app-gmap-button>
	<app-gmap-button
		[options]="mapService.mapButtons.covered_cd"
		(click)="onClickMapButton('covered_cd')"
	></app-gmap-button>
	<app-gmap-button [options]="mapService.mapButtons.network" (click)="onClickMapButton('network')"></app-gmap-button>
	<app-gmap-button [options]="mapService.mapButtons.prospect" (click)="onClickMapButtonProspect()"></app-gmap-button>
	<app-gmap-button [options]="mapService.mapButtons.poi" (click)="onClickMapButton('poi')"></app-gmap-button>

	<!-- Legenda -->
	<div class="m-1">
		<button
			class="map_button key_button"
			(click)="openLegenda()"
			matTooltip="{{ mapService.instant('KEY.KEY') }}"
			matTooltipClass="tooltip-map-button"
			matTooltipPosition="right"
		>
			<img
				class="map_button_img"
				src="{{ mapService.pathImgsMarkers }}/ico-legenda-off.png?v={{ assets_version }}"
				srcset="{{mapService.pathImgsMarkers}}/ico-legenda-off@2x.png 2x"
			/>
			<span class="p-2 d-none">{{ "KEY.KEY" | translate }}</span>
		</button>
	</div>
</div>

<div id="warningProspectModal" class="modal fade" data-keyboard="false" data-backdrop="static">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<button
					type="button"
					class="close"
					aria-label="Close"
					data-dismiss="modal"
					(click)="mapService.close('warningProspectModal')"
				>
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body d-flex flex-column align-items-center justify-content-center">
				<h6>
					Information about network in design phase can be updated without any prior notification.
					<br />
					Open Fiber does not commit to deploy network in design phase
				</h6>
				<button
					mat-stroked-button
					(click)="mapService.close('warningProspectModal'); onClickMapButton('prospect')"
				>
					Close and continue
				</button>
			</div>
		</div>
	</div>
</div>
